const conditionPattern = /^([A-Za-z_$][\w$]*(?:\.[A-Za-z_$][\w$]*)*)\s*(==|!=|>=|<=|>|<)\s*(.+)$/

const parseLiteral = (raw: string): string | number | boolean | null => {
  const value = raw.trim()
  if ((value.startsWith('"') && value.endsWith('"')) || (value.startsWith("'") && value.endsWith("'"))) return value.slice(1, -1)
  if (value === 'true') return true
  if (value === 'false') return false
  if (value === 'null') return null
  const numeric = Number(value)
  return Number.isNaN(numeric) ? value : numeric
}

export const evaluateTourCondition = (condition: string | undefined, values: Record<string, unknown>): boolean => {
  if (!condition) return true
  const match = condition.match(conditionPattern)
  if (!match) return false
  const [, key, operator, rawExpected] = match
  const actual = values[key]
  const expected = parseLiteral(rawExpected)
  switch (operator) {
    case '==': return actual === expected
    case '!=': return actual !== expected
    case '>': return typeof actual === 'number' && typeof expected === 'number' && actual > expected
    case '>=': return typeof actual === 'number' && typeof expected === 'number' && actual >= expected
    case '<': return typeof actual === 'number' && typeof expected === 'number' && actual < expected
    case '<=': return typeof actual === 'number' && typeof expected === 'number' && actual <= expected
    default: return false
  }
}

export const evaluateInputCriteria = (value: string, criteria: string): boolean => {
  const match = criteria.trim().match(/^value\.length\s*(==|!=|>=|<=|>|<)\s*(\d+)$/)
  if (!match) return false
  const expected = Number(match[2])
  return evaluateTourCondition(`value ${match[1]} ${expected}`, { value: value.length })
}

export const resolveTourPath = (template: string, variables: Record<string, string>): string =>
  // Empty strings count as missing — otherwise an unloaded workspace.slug
  // collapses the URL to `/workspace//d` (double slash) which neither matches
  // the tour template nor any real app route.
  template.replace(/:([A-Za-z][\w]*)/g, (_, key: string) => {
    const value = variables[key]
    return value ? encodeURIComponent(value) : `:${key}`
  })

export const pathMatchesTourTemplate = (pathname: string, template: string): boolean => {
  const escaped = template
    .replace(/[.*+?^${}()|[\]\\]/g, '\\$&')
    .replace(/:[A-Za-z][\w]*/g, '[^/]+')
  return new RegExp(`^${escaped}/?$`).test(pathname)
}
